module.exports = __webpack_public_path__ + "img/title.1b13339d.png";